import type {
  AgentListProjectsParams,
  AgentListAvailableProjectsParams,
} from '../api'
import projectService from './agent-project.service'
import { EAgentProjectQueryKey } from './agent-project.types'

export const getAgentListProjectsOptions = (
  params: AgentListProjectsParams,
) => {
  return {
    queryKey: [EAgentProjectQueryKey.AGENT_PROJECT, params],
    queryFn: () => projectService.getAgentListProjects(params),
  }
}

export const getAgentProjectDetailsOptions = (token?: string) => {
  return {
    queryKey: [EAgentProjectQueryKey.AGENT_PROJECT, token],
    queryFn: () => projectService.getAgentProjectDetails(token || ''),
    enabled: !!token,
  }
}

export const agentListAvailableProjectsOptions = (
  params: AgentListAvailableProjectsParams,
) => {
  return {
    queryKey: [EAgentProjectQueryKey.AGENT_LIST_AVAILABLE_PROJECTS],
    queryFn: () => projectService.agentListAvailableProjects(params),
  }
}
